module.exports = __webpack_public_path__ + "static/media/line-varied-dashed.a2b55b63.svg";